export default __webpack_public_path__ + "static/media/tablet-bg-m.5c92c87c.png";